import React, { ReactNode } from 'react';
import { useAuth } from '../../hooks/use-auth';

interface AuthorizorProps {
  allowedRoles: string[];
  children: ReactNode;
  fallback?: ReactNode;
}

const Authorizor: React.FC<AuthorizorProps> = ({
  allowedRoles,
  children,
  fallback = null,
}) => {
  const { user, isLoading } = useAuth();

  // Optionally handle loading state
  if (isLoading) {
    return null; // or a loading spinner
  }

  // Check if user exists and has permission
  const userHasPermission = user && allowedRoles.includes(user.role);

  if (userHasPermission) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

export { Authorizor };

// --------------- Usage ----------------
{
  /* <Authorizor allowedRoles={[ROLES.MANAGER]}>
  <Button
    type="button"
    variant="basic-primary"
    size="medium"
    onClick={handleAddUserClick}
  >
    Add User
  </Button>
</Authorizor>; */
}
